import React from 'react';
import '../css/closeButton.css';
import { CloseButtonIcon } from '../../../../../asset-controller-mod/asset-serv/icons/iconExporter';

export interface CloseButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  'aria-label': ariaLabel = 'Close',
}) => {
  return (
    <button
      type="button"
      className={`scl--cms-components-closeButton ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <CloseButtonIcon className="scl--cms-components-closeButton-icon" />
    </button>
  );
};

export default CloseButton;